'use client';

import { useContext, useMemo } from 'react';

import Lottie from 'lottie-react';

import { ThemeContext } from '../ThemeManager/ThemeProvider';

import assignment from './assignments-empty.json';
import bookRead from './book-read.json';
import favouriteDark from './favourites-empty-dark.json';
import favouriteLight from './favourites-empty-light.json';
import playQuizDa from './play-quiz-da.json';
import playQuizEn from './play-quiz-en.json';
import playQuizNo from './play-quiz-no.json';

export enum Locale {
  'da' = 'da',
  'en' = 'en',
  'no' = 'no',
}

export type AnimationVariant = 'assigned-empty' | 'book-read' | 'favourites-empty' | `play-quiz-${Locale}`;

type AnimationProps = {
  variant: AnimationVariant;
};
export function Animation({ variant }: AnimationProps) {
  const { theme } = useContext(ThemeContext);
  const animationData = useMemo(() => {
    switch (variant) {
      case 'assigned-empty':
        return assignment;
      case 'book-read':
        return bookRead;
      case 'favourites-empty': {
        if (theme === 'dark') {
          return favouriteDark;
        }

        if (theme === 'light') {
          return favouriteLight;
        }
        const browserPrefersDark =
          window && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

        if (browserPrefersDark) {
          return favouriteDark;
        }
        return favouriteLight;
      }
      case 'play-quiz-da':
        return playQuizDa;
      case 'play-quiz-en':
        return playQuizEn;
      case 'play-quiz-no':
        return playQuizNo;
      default:
        return null;
    }
  }, [theme, variant]);

  if (!animationData) {
    return null;
  }

  return <Lottie animationData={animationData} />;
}
